<template>
  <div>
    <b-form @submit="handleClickSave">
      <ElementSelectForm
        id="announcement_notice_type"
        title="お知らせ通知方法"
        :vModel="formdata"
        :options="state"
        :required="true"
        @changed="formChanged"
      ></ElementSelectForm>
      <b-container>
        <b-row>
          <b-col align="right">
            <b-button inline @click="closeModal()" class="mr-2">キャンセル</b-button>
            <b-button inline type="submit" variant="default">保存</b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-form>
  </div>
</template>

<script>
import api from '@/api'
import ElementSelectForm from '@/components/presentationals/ElementSelectForm.vue'
import { getErrorStatus } from '@/transformer/base'

export default {
  name: 'ConfigEdit',
  components: {
    ElementSelectForm
  },
  props: ['state', 'typeid'],
  data() {
    return {
      formdata: this.typeid,
      name: {
        announcement_notice_type: 'announcement_notice_type'
      }
    }
  },
  methods: {
    formChanged(data) {
      this.formdata = data.value
      this.name[data.id] = data.id
    },
    async handleClickSave() {
      try {
        await api.config.save(this.name.announcement_notice_type, this.formdata)
        this.$root.$bvToast.toast('通知方法を変更しました。', {
          variant: 'success',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 3000
        })

        this.closeModal()
        this.$emit('update')
      } catch (err) {
        const apiStatus = getErrorStatus(err)
        const errorMessages = []
        for (const key in apiStatus.errors) {
          errorMessages.push(`・${apiStatus.errors[key]}`)
        }
        this.$root.$bvToast.toast(errorMessages.join('\n'), {
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          toastClass: 'pre-wrap',
          noAutoHide: true
        })
        if (apiStatus.status === 403 || apiStatus.status === 404) {
          // 該当のデータをうまくとれなかった場合は編集画面を閉じて更新
          this.closeModal()
          this.$emit('update')
        }
      }
    },
    closeModal: function () {
      this.$emit('closeModal')
    }
  }
}
</script>
